var _g, _g2, _g3, _g4, _path, _g5, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraveling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 142,
    viewBox: "0 0 146 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5319_3104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4196 95.279L67.502 99.1711L63.9648 103.881C62.2323 106.191 58.5508 104.964 58.5508 102.077V83.4102L70.4196 95.279Z",
    fill: "#878787"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5319_3104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4196 95.279L67.502 99.1711L58.5508 90.2198V83.4102L70.4196 95.279Z",
    fill: "#4C4944"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_5319_3104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6828 43.5056C22.6267 44.2672 22.0504 46.902 23.6006 48.4528L58.5502 83.4102C75.8108 100.671 93.5779 118.43 93.5076 118.36C95.0584 119.91 97.6926 119.334 98.4548 117.278L139.59 6.23518C140.484 3.82412 138.136 1.47682 135.725 2.36954L24.6828 43.5056Z",
    fill: "#BCE0F5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_5319_3104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.665 108.586L39.3912 55.3137C38.8035 54.726 38.8035 53.7737 39.3912 53.1872C39.9789 52.5994 40.9306 52.5994 41.5177 53.1872L93.1324 104.801L121.733 27.5967C122.022 26.8171 122.89 26.4224 123.666 26.7082C124.445 26.9969 124.843 27.8626 124.554 28.641L95.1392 108.044C94.7596 109.067 93.441 109.363 92.665 108.586ZM35.1376 51.0594L33.3744 49.295C32.7867 48.7073 32.7867 47.755 33.3744 47.1679C33.9621 46.5814 34.9144 46.5808 35.5015 47.1685L37.2647 48.9329C37.8524 49.5206 37.8524 50.4729 37.2647 51.0594C36.6758 51.6478 35.7235 51.6454 35.1376 51.0594Z",
    fill: "#023A65"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.203 16.8837C127.792 16.2996 127.792 15.3431 127.203 14.7542C126.638 14.1887 125.645 14.1887 125.08 14.7542C124.484 15.363 124.505 16.308 125.08 16.8837C125.658 17.4624 126.611 17.4744 127.203 16.8837Z",
    fill: "black"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_5319_3104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.198 0.959835L24.1615 42.0947C21.0875 43.2352 20.2056 47.1869 22.5372 49.5186L57.0489 84.0362V102.076C57.029 106.4 62.5971 108.239 65.17 104.784L70.5846 97.5672L92.4508 119.426C94.7662 121.757 98.7317 120.856 99.8681 117.801L103.135 108.982C103.418 108.206 103.021 107.34 102.245 107.051C101.481 106.769 100.591 107.184 100.314 107.941L97.0474 116.754C96.6594 117.792 95.3425 118.062 94.575 117.295C66.0098 88.7368 74.1032 96.8297 60.6835 83.4082L122.95 21.1362C123.524 20.5618 123.549 19.6125 122.95 19.0127C122.385 18.4418 121.392 18.4418 120.827 19.0127L58.5534 81.2793L24.6668 47.389C23.8721 46.5944 24.1957 45.295 25.2082 44.9166L135.935 3.89847L129.333 10.5012C128.749 11.0901 128.749 12.0412 129.333 12.6307C129.908 13.2058 130.859 13.2275 131.456 12.6307L138.066 6.02559L104.488 96.657C104.205 97.433 104.602 98.2993 105.378 98.588C106.142 98.8708 107.032 98.4557 107.315 97.7037C107.315 97.6977 107.315 97.6977 107.315 97.6911L141.002 6.7595C142.347 3.10621 138.769 -0.382852 135.198 0.959835ZM60.0567 87.0428L68.4352 95.4184L62.7637 102.978C61.8385 104.169 60.0567 103.467 60.0567 102.076V87.0428Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.329 101.408C103.571 101.124 102.681 101.54 102.398 102.297C102.11 103.073 102.512 103.94 103.288 104.228C104.131 104.532 104.95 104.068 105.219 103.339C105.507 102.563 105.11 101.696 104.329 101.408Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3993 115.687L40.7867 103.3C41.3745 102.712 41.3745 101.76 40.7867 101.173C40.199 100.586 39.2473 100.585 38.6602 101.173L26.2728 113.56C25.6851 114.147 25.6851 115.099 26.2728 115.686C26.8606 116.273 27.8116 116.274 28.3993 115.687Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6534 93.6263C33.0657 93.0386 32.114 93.0386 31.5269 93.6263L14.5959 110.558C12.0393 113.113 7.88067 113.113 5.32523 110.558C2.76979 108.002 2.76979 103.843 5.32523 101.287C7.88789 98.7246 12.0333 98.7246 14.5959 101.287C15.1836 101.875 16.1353 101.875 16.7224 101.287C17.3096 100.7 17.3102 99.7478 16.7224 99.1607C12.9843 95.4226 6.93561 95.422 3.19871 99.1607C-0.529777 102.889 -0.529777 108.956 3.19871 112.684C6.92539 116.412 12.9939 116.413 16.7224 112.684L33.6534 95.7529C34.2411 95.1651 34.2411 94.2135 33.6534 93.6263Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2084 108.308L29.2768 125.239C25.5483 128.967 25.5483 135.034 29.2768 138.762C35.2437 144.729 45.6026 140.545 45.6026 132.001C45.6026 129.446 44.6077 127.045 42.8012 125.239C42.2134 124.651 41.2618 124.651 40.6746 125.239C40.0875 125.826 40.0869 126.778 40.6746 127.365C41.9133 128.604 42.5948 130.25 42.5948 132.001C42.5948 137.794 35.5391 140.768 31.4034 136.636C28.8479 134.08 28.8479 129.921 31.4034 127.365L48.3349 110.434C48.9227 109.847 48.9227 108.895 48.3349 108.308C47.7472 107.72 46.7961 107.72 46.2084 108.308Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5319_3104",
    x: 54.5508,
    y: 83.4102,
    width: 19.8691,
    height: 29.6787,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5319_3104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5319_3104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5319_3104",
    x: 54.5508,
    y: 83.4102,
    width: 19.8691,
    height: 23.7607,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5319_3104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5319_3104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_5319_3104",
    x: 18.7188,
    y: 2.17578,
    width: 125.066,
    height: 125.065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5319_3104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5319_3104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_5319_3104",
    x: 28.9336,
    y: 26.6152,
    width: 99.7148,
    height: 90.4111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5319_3104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5319_3104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_5319_3104",
    x: 17.2148,
    y: 0.666016,
    width: 128.078,
    height: 128.076,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5319_3104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5319_3104",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraveling);
export default __webpack_public_path__ + "static/media/traveling.e87d1f02b16c2aebc317ee1a293a2056.svg";
export { ForwardRef as ReactComponent };